export default __webpack_public_path__ + "static/media/ic_round-email.2f85c884.svg";